import React, { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/context/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import ErrorBoundary from '@/components/ErrorBoundary';

import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Feed from '@/pages/Feed';
import Reader from '@/pages/Reader';
import Generate from '@/pages/Generate';
import Preview from '@/pages/Preview';
import Success from '@/pages/Success';
import History from '@/pages/History';
import Settings from '@/pages/Settings';
import SitesSettings from '@/pages/SitesSettings';
import Admin from '@/pages/Admin';
import FeedsSettings from '@/pages/FeedsSettings';

export default function App() {
  useEffect(() => {
    document.title = 'Auto Radko — Publication WordPress automatisée';
  }, []);
  return (
    <div className="App">
      <ErrorBoundary>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/" element={<ProtectedRoute><Feed /></ProtectedRoute>} />
              <Route path="/reader" element={<ProtectedRoute><Reader /></ProtectedRoute>} />
              <Route path="/generate" element={<ProtectedRoute><Generate /></ProtectedRoute>} />
              <Route path="/preview/:articleId" element={<ProtectedRoute><Preview /></ProtectedRoute>} />
              <Route path="/success/:articleId" element={<ProtectedRoute><Success /></ProtectedRoute>} />
              <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              <Route path="/settings/sites" element={<ProtectedRoute><SitesSettings /></ProtectedRoute>} />
              <Route path="/settings/feeds" element={<ProtectedRoute><FeedsSettings /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}
